import angular from 'angular';
import runExportComponent from './runExport.component';

let runExportModule = angular.module('runExport', []).component('runExport', runExportComponent);

export default runExportModule;



// WEBPACK FOOTER //
// ./app/components/runExport/runExport.js